document.addEventListener('DOMContentLoaded', function () {
    function checkVisibility() {
        document.querySelectorAll('.animate-load, .animate-view').forEach((card) => {
            const rect = card.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            if (rect.top < windowHeight && rect.bottom > 0) {
                console.log('Element is visible:', card);
                if (!card.classList.contains('visible')) {
                    card.classList.add('visible');
                    card.classList.remove('invisible');
                }
            } else {
                if (!card.classList.contains('animate-load')) {
                    card.classList.remove('visible');
                    card.classList.add('invisible');
                }
            }
        });
    }
    window.addEventListener('scroll', checkVisibility);
    window.addEventListener('load', checkVisibility);
});
